import React from 'react';

import { useSelector } from 'react-redux';

import FieldSelect from '../commons/FieldSelect';
import FieldText from '../commons/FieldText';

const PersonalData = () => {
  const genders = useSelector((state) => state.catalogs.genders);
  const maritalStatuses = useSelector((state) => state.catalogs.maritalStatuses);
  const occupations = useSelector((state) => state.catalogs.occupations);

  return (
    <div>
      <h3>Datos Personales</h3>
      <hr className="solid" />
      <div className="field-row">
        <FieldText
          label="Email"
          name="email"
          required />
        <div className="field -double-input">
          <FieldText
            maxLength={10}
            label="Teléfono celular"
            name="cellphone"
            placeholder="000 0000 0000"
            className="field -input -half"
            required />
          <FieldSelect
            label="Genero"
            required
            keyLabel="name"
            keyName="id"
            list={genders}
            className="field -input -half"
            name="gender" />
        </div>
      </div>
      <div className="field-row">
        <div className="field -double-input">
          <FieldSelect
            label="Estado Civil"
            required
            className="field -input -half"
            keyLabel="name"
            keyName="id"
            list={maritalStatuses}
            name="maritalStatus" />
        </div>
        <FieldSelect
          label="Ocupación"
          required
          keyLabel="name"
          keyName="id"
          list={occupations}
          name="occupation" />
      </div>
    </div>
  );
};

export default PersonalData;
